export default __webpack_public_path__ + "8810e8b.png";